































































import { Component, Prop, Mixins } from "vue-property-decorator";
import RequestPromises from "@/mixins/requestPromises";
import { DataModules } from "@/store/modules/data";
import { IContract, IContractProduct } from "@/models/contracts";
import { BACKEND_DATE_FORMAT } from "@/data/date";

interface IDueDateModalForm {
  create_documents: boolean;
  next_due_date: Date;
}

@Component
export default class ContractProductDueDateModal extends Mixins(
  RequestPromises
) {
  // Props
  @Prop({ required: true })
  public nextDueDate!: Date;
  @Prop({ required: true })
  public contractId!: IContract["id"];
  @Prop({ required: true })
  public productId!: IContractProduct["id"];
  // Data
  public isProcessing = false;
  public form: IDueDateModalForm = {
    create_documents: true,
    next_due_date: this.nextDueDate
  };

  public get minDate() {
    return this.$moment()
      .startOf("day")
      .toDate();
  }

  public get isExtension() {
    return this.form.next_due_date > this.nextDueDate;
  }

  public get daysDifference() {
    const oldDueDate = this.$moment(this.nextDueDate);
    const newDueDate = this.$moment(this.form.next_due_date);
    return Math.abs(oldDueDate.diff(newDueDate, "days"));
  }

  public get formIsValid() {
    if (!this.$_.isDate(this.form.next_due_date)) return false;
    if (this.$_.isEqual(this.nextDueDate, this.form.next_due_date))
      return false;
    return true;
  }

  public async validateBeforeSubmit() {
    if (!this.formIsValid) return;
    this.isProcessing = true;
    try {
      await this.$store.dispatch(
        `data/${DataModules.CONTRACTS_PRODUCTS}/modify`,
        {
          contractId: this.contractId,
          contractProductId: this.productId,
          payload: {
            ...this.form,
            next_due_date: this.$moment(this.form.next_due_date).format(
              BACKEND_DATE_FORMAT
            )
          }
        }
      );
      this.$emit("close");
      this.$emit("changed");
    } catch (error) {
      this.$store.dispatch("api/handleError", error);
    } finally {
      this.isProcessing = false;
    }
  }
}
